import request from "../request";
import Url from "../url/dangerous";

const getRisk_factorsByMemberid = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getRisk_factorsByMemberid + path, data, options);
};
const getMyRisk_factorsByMemberid = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getMyRisk_factorsByMemberid + path, data, options);
};
const setRisk_factors = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setRisk_factors + path, data, options);
};
const updateRisk_factors = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateRisk_factors + path, data, options);
};

export default {
  getRisk_factorsByMemberid,
  getMyRisk_factorsByMemberid,
  setRisk_factors,
  updateRisk_factors,
};
